<template>
  <div class="modal__main">
    <BottomSheet 
      v-show="currentScreenSize <= 768 && modelValue"
      v-model="showBottomModal"
      @opened="onOpen"
      @closed="onClose"
    >
      <template #content>
        <div class="content__container">
          <UniModal :modalList="modalList" @close="closeModal"/>
        </div>
      </template>
    </BottomSheet>
    <teleport to="body">
      <div v-if="modelValue && currentScreenSize > 768" class="modal" :style="{ zIndex: 10000 }">
        <div class="modal__background" @click="closeModal"></div>
        <div class="modal__container">
        	<div class="modal-scroll__container">
          	<UniModal :modalList="modalList" @close="closeModal"/>
          </div>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
import UniModal from '@/components/UI/Modal/UniModal/index.vue'
import { mapGetters } from "vuex"
import { screenSizes } from '@/config/screen-sizes.js'
import BottomSheet from "@/components/UI/Modal/BottomSheet.vue";

export default {
  components: { BottomSheet, UniModal },
  props: ['modelValue', 'modalList'],
  emits: ['update:modelValue'],
  watch: {
    modelValue () {
      if(this.currentScreenSize <= 768 && this.modelValue) this.showBottomModal = this.modelValue
    },
  },
  data () {
    return {
      showBottomModal: false
    }
  },
  methods: {
    onOpen () {
    },
    onClose () {
    },
    closeModal() {
      this.showBottomModal = false
      this.$emit('update:modelValue', false)
    }
  },
  computed: {
    ...mapGetters("landing", ["landingSettings"]),
    currentScreenSize() {
      let ind = screenSizes?.find(item => item.title === this.landingSettings?.size?.width + 'px');
      ind = ind?.title?.replace('px', '')
      if(ind <= 768) {
        var r = document.querySelector(':root');
        r.style.setProperty('--vsbs-background', 'white');
        r.style.setProperty('--vsbs-handle-background', 'black');
      }

      return ind
    },
  }
}
</script>


<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal__background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
}

.modal__container {
  position: relative;
  background: var(--color-0);
  padding: 1rem;
  border-radius: 0.5rem;
  z-index: 10001;
  max-width: 40rem;
  width: 90%;
  box-sizing: border-box;
	overflow: hidden;
	max-height: 95vh;
}

.content__container {
	height: 100%;
	min-height: 85vh;
	padding-bottom: 5rem;
}
.content__container * {
	color: var(--color-1)
}
.modal-scroll__container {
  max-height: 80vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.modal-scroll__container::-webkit-scrollbar {
  width: 0; 
}

.modal-scroll__container::-webkit-scrollbar-track {
  background: transparent;
}

.modal-scroll__container::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 0.5rem;
}

.modal__main {
  
}
</style>
